var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoostWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "25px",
    viewBox: "0 0 16 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBoostWhite@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.83807277,24.9406685 C5.16878576,25.082026 5.55330736,24.9640084 5.74647148,24.6588813 L14.5355366,10.6940333 C14.6778707,10.4680079 14.6864644,10.1826074 14.5577046,9.94945303 C14.4289448,9.71556624 14.1828998,9.57035135 13.9161029,9.57035135 L8.05028078,9.57035135 L10.2318244,0.912682709 C10.3198127,0.562926743 10.1416877,0.201696165 9.81053522,0.0593621374 C9.48153121,-0.082239468 9.0945682,0.0364617398 8.9021365,0.341149332 L0.113071337,14.3059973 C-0.0292626901,14.5320228 -0.0378564427,14.8174233 0.090903362,15.0505776 C0.219663167,15.2844644 0.465708163,15.4296793 0.732505119,15.4296793 L6.59832721,15.4296793 L4.41678358,24.0873479 C4.32879527,24.4371527 4.5068715,24.7983345 4.83807277,24.9406685 L4.83807277,24.9406685 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guest",
    transform: "translate(-60.000000, -368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(5.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(23.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83968471,-8.81588469 C18.9251731,-8.81588469 28.757416,1.01627256 28.757416,13.1015897 C27.6599883,42.1308542 -13.9761669,42.1387309 -15.0780465,13.1018466 C-15.0780465,1.01635818 -5.24580368,-8.81588469 6.83968471,-8.81588469 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoostWhite);
export default __webpack_public_path__ + "static/media/icBoostWhite.7d6ef9528f817fc4a37e641b18b74842.svg";
export { ForwardRef as ReactComponent };